import script from "./PaymentMethodJP.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodJP.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethodJP.vue?vue&type=style&index=0&id=5800bc81&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5800bc81"]])

export default __exports__